import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { AddMiniIcon } from '@calendly/ui/components/icons'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { difference } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

import { LIMIT_TYPES } from './constants'
import { getSummary } from './get_summary'
import { LimitField } from './limit_field'

const AddButton = ({ children, ...props }) => (
  <MinimalButton {...props}>
    <AddMiniIcon />
    {children}
  </MinimalButton>
)

const EventLimitsLocked = () => {
  const { values: { dailyLimit, weeklyLimit, monthlyLimit } } = useFormContext()

  return getSummary({ dailyLimit, weeklyLimit, monthlyLimit })
}

const EventLimitsFields = ({ v3Style, addButtonComponent: AddButtonComponent = AddButton }) => {
  const { values: { dailyLimit, weeklyLimit, monthlyLimit }, setFieldValue } = useFormContext()
  const limitTypes = { dailyLimit, weeklyLimit, monthlyLimit }

  const [observableLimitTypes, setObservableLimitTypes] = useState(
    LIMIT_TYPES.filter((type) => limitTypes[type] !== undefined)
  )

  const showButton = observableLimitTypes.length < 3

  const addFirstLimitText = v3Style
    ? I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.set_limit')
    : I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.max_meetings.add_limit')

  const buttonText = observableLimitTypes.length === 0
    ? addFirstLimitText
    : I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.max_meetings.add_another_limit')

  const [lastAddedType, setLastAddedType] = useState(null)
  const inputRefs = useRef({})

  const onAddLimit = () => {
    const limitType = difference(LIMIT_TYPES, observableLimitTypes)[0]
    setObservableLimitTypes([...observableLimitTypes, limitType])
    setFieldValue(limitType, '')
    setLastAddedType(limitType)
  }

  useEffect(() => {
    if (!lastAddedType) return

    const el = inputRefs.current[lastAddedType]
    if (el && typeof el.focus === 'function') {
      el.focus()
      setLastAddedType(null)
    }
  }, [observableLimitTypes, lastAddedType])

  return (
    <>
      {observableLimitTypes.map((limitType) => (
        <LimitField
          key={limitType}
          limitType={limitType}
          observableLimitTypes={observableLimitTypes}
          setObservableLimitTypes={setObservableLimitTypes}
          v3Style={v3Style}
          ref={(el) => {
            inputRefs.current[limitType] = el
          }}
        />
      ))}
      {showButton && (
        <AddButtonComponent onClick={onAddLimit}>
          {buttonText}
        </AddButtonComponent>
      )}
    </>
  )
}

export const EventLimits = ({ isLocked, ...props }) => (
  !isLocked ? <EventLimitsFields {...props} /> : <EventLimitsLocked {...props} />
)
